export default __webpack_public_path__ + "static/media/modal-checkmark.8bf75542.png";